'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/* eslint-disable typescript-sort-keys/string-enum */ exports.Widths = void 0;
(function(Widths) {
    Widths["None"] = '';
    Widths["Xxsmall"] = 'xxsmall';
    Widths["Xsmall"] = 'xsmall';
    Widths["Small"] = 'small';
    Widths["Medium"] = 'medium';
    Widths["Large"] = 'large';
    Widths["Xlarge"] = 'xlarge';
    Widths["Xxlarge"] = 'xxlarge';
})(exports.Widths || (exports.Widths = {}));
//# sourceMappingURL=widths.js.map
